import React from "react";
import styles from "./Footer.module.scss";

const FooterUI = () => {
  return (
    <footer className={styles.footer}>Made with 🤍 by Aurora Sirigu</footer>
  );
};

export default FooterUI;
